module.exports = __webpack_public_path__ + "media/img/city_and_slider-3170b13e.png";